import { render, staticRenderFns } from "./SplashScreen.vue?vue&type=template&id=8b5fbc14&scoped=true"
import script from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"
export * from "./SplashScreen.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SplashScreen.vue?vue&type=style&index=0&id=8b5fbc14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5fbc14",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LtkFullLogo: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/LtkFullLogo/index.vue').default,CRow: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CGrid/CRow.vue').default,COverlay: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/COverlay/COverlay.vue').default})
